var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.390625,
    height: 12.954102,
    viewBox: "0 0 15.3906 12.9541",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1406 0.147461L0.505859 5.43262C-0.0429688 5.67871 -0.228516 6.17139 0.373047 6.43896L3.87109 7.55615L12.3291 2.30225C12.791 1.97266 13.2637 2.06055 12.8564 2.42334L5.59277 9.03418L5.36426 11.832C5.57617 12.2642 5.96289 12.2661 6.20996 12.0513L8.21973 10.1401L11.6611 12.731C12.4609 13.2065 12.8955 12.8994 13.0674 12.0273L15.3252 1.28223C15.5596 0.208984 15.1602 -0.26416 14.1406 0.147461Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.7eb155c18d219a6324fa0803a97ee58e.svg";
export { ForwardRef as ReactComponent };